import { Typography } from '@twistopayments/design-system/components/atoms/typography'
import { hiddenDown, hiddenUp } from '@twistopayments/design-system/styles'

import type { SectionsAppComponent } from '@twisto/api-cms'

import { useHighlightedText } from 'homepage/libs/hooks'

import { Button, StoreButton, StrapiMedia } from '../../atoms'
import { PrimaryDownloadWidget } from '../../molecules'

import * as styles from './app.styles'

export const AppSection = ({
  title,
  highlighted,
  description,
  download,
  cta,
  image,
  theme,
}: SectionsAppComponent) => {
  const { before, after, highlight } = useHighlightedText(title, highlighted)

  const primaryCta = cta ? cta[0] : null
  const secondaryCta = cta ? cta[1] : null

  const isLight = theme === 'light'

  return (
    <section css={[styles.section, isLight && styles.light]}>
      <div css={styles.content}>
        {image && (
          <div css={[hiddenUp('smMd'), isLight && styles.image]}>
            <StrapiMedia {...image} />
          </div>
        )}
        <div css={[styles.text, isLight && styles.textLight]}>
          <Typography css={styles.title} fontWeight="heavy" variant="h2">
            {before}
            <span css={styles.highlighted}>{highlight}</span>
            {after}
          </Typography>

          <Typography css={styles.description} variant="b1">
            {description}
          </Typography>

          {cta?.length ? (
            <div css={styles.cta}>
              {primaryCta?.text && primaryCta.link && (
                <Button
                  {...primaryCta}
                  url={primaryCta.link}
                  variant={isLight ? 'default' : 'inverted'}
                />
              )}
              {secondaryCta?.text && secondaryCta.link && (
                <Button
                  {...secondaryCta}
                  url={secondaryCta.link}
                  variant={isLight ? 'outlined' : 'outlinedInverted'}
                />
              )}
            </div>
          ) : null}

          {download && (
            <>
              {!download.extended && (
                <>
                  <Typography
                    css={styles.description}
                    fontWeight="heavy"
                    variant="b1"
                  >
                    {download.headline}
                  </Typography>

                  <div css={styles.stores}>
                    {download.stores?.map(({ id, storeLogo, url }) => (
                      <StoreButton key={id} storeLogo={storeLogo} url={url} />
                    ))}
                  </div>
                </>
              )}
              <PrimaryDownloadWidget {...download} />
            </>
          )}
        </div>
        {image && (
          <div css={[hiddenDown('smMd'), isLight && styles.image]}>
            <StrapiMedia {...image} />
          </div>
        )}
      </div>
    </section>
  )
}
